"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordModalButton = void 0;
const modal_button_1 = require("../../components/modal/modal-button");
class PasswordModalButton extends modal_button_1.ModalButton {
    mountComponent() {
        super.mountComponent();
        this.focus();
    }
}
exports.PasswordModalButton = PasswordModalButton;
